import {immerable} from "immer";
import StoreyMeasures from "./storey-measures.ts";
import Measure from "./measure.ts";

class BuildingMeasures {
    [immerable] = true;
    
    id: string;
    
    name: string;
    
    storeys: StoreyMeasures[] = [];
    
    constructor(id: string, name: string) {
        this.id = id;
        this.name = name;
    }
    
    getStorey(storeyId: string) {
        return this.storeys.find(s => s.id === storeyId);
    }
    
    editMeasure(storeyId: string, measureId: string, measure: Measure): void {
        const storey = this.storeys.find(s => s.id === storeyId);
        if(storey == null) return;
       storey.editMeasure(measureId, measure);
    }
}

export default BuildingMeasures;